export function IsObject(value) {
    return (typeof value === 'object') && (value !== null);
}
//# sourceMappingURL=IsObject.js.map